export function availableSetSelectionRange(type: string) {
  return ["text", "search", "url", "tel", "password"].includes(type);
}

export function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0");
}

export function formatDate(date = new Date()) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
}
